module.exports = __webpack_public_path__ + "img/2-4.da78bde5.png";